const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

let lastAddOrigin = null;
let lastCelebratedAt = 0;

function captureAddOrigin(event) {
  const trigger = event.target.closest(
    'add-to-cart-component button, .sticky-add-to-cart__button, button[name="add"], button[type="submit"][name="add"]'
  );

  if (!trigger || trigger.disabled) return;

  const rect = trigger.getBoundingClientRect();
  lastAddOrigin = {
    x: rect.left + rect.width / 2,
    y: rect.top + rect.height / 2,
    time: performance.now(),
  };
}

function getCartTarget() {
  return (
    document.querySelector('[data-testid="cart-icon"]') ||
    document.querySelector('.header-actions__cart-icon') ||
    document.querySelector('[data-testid="cart-drawer-trigger"]')
  );
}

function makeSparkles(x, y) {
  const offsets = [
    [-18, 28, 105],
    [-11, 39, 155],
    [-4, 31, 75],
    [4, 43, 130],
    [11, 26, 210],
    [18, 36, 250],
    [-14, 50, 185],
    [1, 54, 310],
    [15, 48, 235],
  ];

  offsets.forEach(([dx, dy, rotation], index) => {
    const sparkle = document.createElement('span');
    sparkle.className = 'hf-cart-magic-sparkle';
    sparkle.style.left = `${x}px`;
    sparkle.style.top = `${y}px`;
    sparkle.style.setProperty('--hf-sparkle-x', `${dx}px`);
    sparkle.style.setProperty('--hf-sparkle-y', `${dy}px`);
    sparkle.style.setProperty('--hf-sparkle-rotate', `${rotation}deg`);
    sparkle.style.animationDelay = `${index * 18}ms`;
    document.body.appendChild(sparkle);
    window.setTimeout(() => sparkle.remove(), 950);
  });
}

function celebrateAddToCart() {
  if (reduceMotion.matches || !lastAddOrigin) return;

  const now = performance.now();
  if (now - lastCelebratedAt < 650 || now - lastAddOrigin.time > 5000) return;

  const cartTarget = getCartTarget();
  if (!cartTarget) return;

  lastCelebratedAt = now;

  const cartRect = cartTarget.getBoundingClientRect();
  const endX = cartRect.left + cartRect.width / 2;
  const endY = cartRect.top + cartRect.height / 2;
  const startX = lastAddOrigin.x;
  const startY = lastAddOrigin.y;

  const orb = document.createElement('span');
  orb.className = 'hf-cart-magic-orb';
  orb.style.left = `${startX}px`;
  orb.style.top = `${startY}px`;
  document.body.appendChild(orb);

  const travelX = endX - startX;
  const travelY = endY - startY;
  const lift = Math.min(150, Math.max(70, Math.abs(travelY) * .18));

  const animation = orb.animate(
    [
      { transform: 'translate(0, 0) scale(.72)', opacity: .2, offset: 0 },
      { transform: `translate(${travelX * .12}px, ${travelY * .08 - lift * .48}px) scale(1.2)`, opacity: 1, offset: .2 },
      { transform: `translate(${travelX * .58}px, ${travelY * .50 - lift}px) scale(.98)`, opacity: 1, offset: .58 },
      { transform: `translate(${travelX}px, ${travelY}px) scale(.42)`, opacity: .95, offset: 1 },
    ],
    {
      duration: 720,
      easing: 'cubic-bezier(.2,.72,.28,1)',
      fill: 'forwards',
    }
  );

  animation.finished
    .catch(() => {})
    .then(() => {
      orb.remove();

      cartTarget.classList.remove('hf-cart-magic-cart-pop');
      void cartTarget.offsetWidth;
      cartTarget.classList.add('hf-cart-magic-cart-pop');

      makeSparkles(endX, cartRect.bottom - 1);

      window.setTimeout(() => {
        cartTarget.classList.remove('hf-cart-magic-cart-pop');
      }, 480);
    });
}

document.addEventListener('pointerdown', captureAddOrigin, true);
document.addEventListener('click', captureAddOrigin, true);

document.addEventListener('cart:update', (event) => {
  const data = event.detail?.data;
  if (data?.source !== 'product-form-component' || data?.didError) return;
  celebrateAddToCart();
});